import { z } from "zod";

// CMS never issues S, L, O, I, B or Z in an MBI, to avoid confusion with 5, 1, 0 and 2.
const LETTER = "[ACDEFGHJKMNPQRTUVWXY]";
const ALPHANUMERIC = "[0-9ACDEFGHJKMNPQRTUVWXY]";

/**
 * An MBI is 11 characters with a fixed shape per position: a non-zero digit, then alternating
 * letters, alphanumerics and digits. There is no checksum, so this catches malformed input but
 * not a valid-looking wrong number.
 */
export const MBI_REGEX = new RegExp(
  `^[1-9]${LETTER}${ALPHANUMERIC}\\d${LETTER}${ALPHANUMERIC}\\d${LETTER}${LETTER}\\d\\d$`,
);

/** Cards print the MBI grouped, e.g. 1EG4-TE5-MK73. */
export const normalizeMbi = (value: string): string =>
  value.toUpperCase().replace(/[^0-9A-Z]/g, "");

export const mbiZodString = z
  .string()
  .transform(normalizeMbi)
  .refine((value) => value.length > 0, {
    message: "Medicare number is required",
  })
  .refine((value) => MBI_REGEX.test(value), {
    message: "Enter the 11-character Medicare number shown on the card",
  });

/** The same rule, for a field the user may leave empty (e.g. a non-Medicare patient). */
export const optionalMbiZodString = z
  .string()
  .transform(normalizeMbi)
  .refine((value) => value === "" || MBI_REGEX.test(value), {
    message: "Enter the 11-character Medicare number shown on the card",
  });
